import React, { useRef, useEffect, useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { StandaloneSearchBox } from '@react-google-maps/api';
import { isUrl, parseGoogleMapsLink } from "utils/googleMaps";
import Spinner from "components/Spinner";
import useGoogleMapsLoader from "hooks/useGoogleMapsLoader";

const GoogleSearch = createGlobalStyle`
  .pac-container {
        z-index: 9999;
    }
`;

const Container = styled.div`
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    position: relative;

    span {
        position: absolute;
        top: 30%;
        right: 8px;
        width: 14px;
        height: 14px;
    }
`;
const Input = styled.input`
    padding: 9px 3px;
    width: 90%;
    display: flex;
    height: 100%;
    width: 100%;
    outline: hidden;
`;

const GoogleMapSearchComponent = (({ locationName, ...props }) => {
    const searchBoxRef = useRef(null);
    const [searchInputValue, setSearchInputValue] = useState("");
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const inputRef = useRef(null);
    const { isLoaded } = useGoogleMapsLoader();


    const onPlacesChanged = () => {
        const places = searchBoxRef.current.getPlaces();
        // eslint-disable-next-line array-callback-return
        places.map(({ formatted_address, geometry: { location }, name }) => {
            props.handleSearchInput(formatted_address, location.lat(), location.lng(), name);
        });
    };

    const handleInputLink = async (inputValue) => {
        const coordinates = await parseGoogleMapsLink(inputValue);
        if (typeof coordinates === "object") {
            props.handleSearchInput(null, coordinates.lat, coordinates.lng, inputValue);
            setIsSearchLoading(false);
        } else {
            setSearchInputValue(coordinates);
            setIsSearchLoading(false);
            inputRef.current.blur();
            inputRef.current.focus();
        }
    };

    useEffect(() => {
        (locationName !== "" || locationName !== undefined) && setSearchInputValue(locationName);
    }, [locationName]);


    const clearInputSearch = () => {
        setSearchInputValue("");
        inputRef.current.blur();
        inputRef.current.focus();
        props.clearLocation();
    };
    const onSearchBoxMounted = (ref) => {
        searchBoxRef.current = ref;
    };
    return (
        <Container>
            <GoogleSearch />
            {isLoaded && <StandaloneSearchBox
                bounds={props.bounds}
                onPlacesChanged={onPlacesChanged}
                onLoad={onSearchBoxMounted}
            >
                <Input
                    type="text"
                    ref={inputRef}
                    placeholder="Search Here"
                    value={searchInputValue}
                    onChange={(e) => {
                        // Check if the value is a link
                        if (isUrl(e.target.value)) {
                            setIsSearchLoading(true);
                            handleInputLink(e.target.value);
                        } else {
                            setSearchInputValue(searchBoxRef.current?.value);
                        }
                    }}
                />
            </StandaloneSearchBox>}
            {!isSearchLoading ? (
                <span className="top-[30%] right-[8px] absolute">
                    {searchBoxRef.current?.value || locationName ? (
                        <CloseIcon onClick={() => clearInputSearch()} />
                    ) : (
                        <SearchIcon />
                    )}
                </span>
            ) : (
                <span className="top-[30%] right-[8px] absolute">
                    <Spinner />
                </span>
            )}
        </Container>
    );
});
export default GoogleMapSearchComponent;
